type Instructor = {
  id: string
  role: 'lead' | 'contributor'
  user: { id: string; name: string; avatarUrl?: string | null; bio?: string | null }
}

type InstructorSectionProps = {
  instructors?: Instructor[]
}

export default function InstructorSection({ instructors }: InstructorSectionProps) {
  if (!instructors || instructors.length === 0) return null

  const ordered = [...instructors].sort((a, b) => (a.role === 'lead' ? -1 : b.role === 'lead' ? 1 : 0))

  return (
    <section>
      <h2 className="text-2xl font-semibold text-foreground tracking-tight mb-6">Conoce quién enseña el curso</h2>
      <div className="grid gap-6 sm:grid-cols-2">
        {ordered.map(({ id, user }) => (
          <div key={id} className="flex items-start gap-4 rounded-xl border border-border bg-foreground/[0.02] p-6">
            {user.avatarUrl ? (
              <img src={user.avatarUrl} alt={user.name} className="h-14 w-14 shrink-0 rounded-full object-cover" />
            ) : (
              <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-primary/20 text-lg font-bold text-primary">
                {user.name.charAt(0).toUpperCase()}
              </span>
            )}
            <div className="min-w-0">
              <p className="font-semibold text-foreground">{user.name}</p>
              {user.bio && (
                <p className="mt-1 text-sm text-muted-foreground leading-relaxed line-clamp-3">{user.bio}</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}
